export interface Cuisine {
  id: string
  name: string
  description?: string
  displayOrder?: number
}

export interface Restaurant {
  _id: string
  id?: string // Optional for compatibility with PostgreSQL UUID format
  name: string
  restaurantType: string
  cuisines: Cuisine[]
  owner: {
    _id: string
    name: string
  }
  members?: {
    _id: string
    name: string
    avatar?: string | null
  }[]
  createdAt?: Date | string
  updatedAt?: Date | string
}

export const RESTAURANT_TYPES = [
  'Fine Dining',
  'Casual Dining',
  'Fast Casual',
  'Fast Food',
  'Cafe',
  'Bistro',
  'Brasserie',
  'Food Truck',
  'Pop-up',
  'Buffet',
  'Family Style',
  'Tapas / Small Plates',
  'Bar & Grill',
  'Sports Bar',
  'Wine Bar',
  'Brewery / Brewpub',
  'Rooftop',
  'Beach / Poolside',
  'Food Hall',
  'Other',
] as const
